import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Flex, Spin } from "antd";

export default function Loading() {
  return (
    <Flex
      align="center"
      justify="center"
      style={{ width: "100%", height: "100vh" }}
    >
      <Spin
        indicator={<Loading3QuartersOutlined spin style={{color: "#61b91c", fontSize: "100px"}}/>}
      />
    </Flex>
  );
}
